export class FiltrosRepComercial{
   
   Usuario : string ='';
   Estado: string = '';

}